var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAplicacoesWeb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "aplicacoes-web",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 171 171",
    style: {
      enableBackground: "new 0 0 171 171"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#DD5100;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "aplicacoes-web_1_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M125.6,40.5H45.4c-6.8,0-12.3,5.5-12.3,12.3v49.1c0,6.8,5.5,12.3,12.3,12.3h36v8.2H60.1v8.2h50.7v-8.2H89.6 v-8.2h36c6.8,0,12.3-5.5,12.3-12.3V52.8C137.9,46,132.4,40.5,125.6,40.5z M129.7,101.9c0,2.3-1.8,4.1-4.1,4.1H45.4 c-2.3,0-4.1-1.8-4.1-4.1V52.8c0-2.3,1.8-4.1,4.1-4.1h80.2c2.3,0,4.1,1.8,4.1,4.1V101.9z M79,54.8V63c-2.3,0-4.1,1.8-4.1,4.1v2 c0,3.1-1.2,6-3.1,8.2c1.9,2.2,3.1,5,3.1,8.2v2c0,2.3,1.8,4.1,4.1,4.1v8.2c-6.8,0-12.3-5.5-12.3-12.3v-2c0-2.3-1.8-4.1-4.1-4.1v-8.2 c2.3,0,4.1-1.8,4.1-4.1v-2C66.7,60.4,72.2,54.8,79,54.8z M109.6,73.2v8.2c-2.3,0-4.1,1.8-4.1,4.1v2c0,6.8-5.5,12.3-12.3,12.3v-8.2 c2.3,0,4.1-1.8,4.1-4.1v-2c0-3.1,1.2-6,3.1-8.2c-1.9-2.2-3.1-5-3.1-8.2v-2c0-2.3-1.8-4.1-4.1-4.1v-8.2c6.8,0,12.3,5.5,12.3,12.3v2 C105.6,71.4,107.4,73.2,109.6,73.2z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAplicacoesWeb);
export default __webpack_public_path__ + "static/media/aplicacoes-web.6b1584ee1b77ecb753638d215191bb87.svg";
export { ForwardRef as ReactComponent };